import React from 'react';
import { motion } from 'framer-motion';
import { Home, MessageSquare, Plus, Users } from 'lucide-react';
import { categoryFilterOptions, ForumCategory } from './forumLabels';

type Props = {
  sidebarOpen: boolean;
  isMobile: boolean;
  category: ForumCategory | '';
  onGoHome: () => void;
  onBackToList: () => void;
  onCategoryChange: (c: ForumCategory | '') => void;
  onNewTopic: () => void;
};

const ForumSidebar: React.FC<Props> = ({
  sidebarOpen,
  isMobile,
  category,
  onGoHome,
  onBackToList,
  onCategoryChange,
  onNewTopic,
}) => (
  <motion.aside
    initial={false}
    animate={{
      width: isMobile ? (sidebarOpen ? 260 : 0) : sidebarOpen ? 260 : 72,
      opacity: 1,
    }}
    className="forum-sidebar"
    style={{
      position: isMobile ? 'fixed' : 'relative',
      paddingTop: isMobile ? '72px' : '24px',
    }}
  >
    <div className="forum-sidebar__inner">
      <div className="forum-sidebar__brand">
        <div className="forum-sidebar__logo">
          <Users size={20} color="white" />
        </div>
        {sidebarOpen && (
          <div>
            <div className="forum-sidebar__title">Topluluk</div>
            <div className="forum-sidebar__subtitle">Forum</div>
          </div>
        )}
      </div>

      <nav className="forum-sidebar__nav">
        <button type="button" onClick={onGoHome} className="forum-nav-btn">
          <Home size={18} />
          {sidebarOpen && <span>Ana sayfa</span>}
        </button>
        <button type="button" onClick={onBackToList} className="forum-nav-btn forum-nav-btn--active">
          <MessageSquare size={18} />
          {sidebarOpen && <span>Tüm konular</span>}
        </button>
      </nav>

      {sidebarOpen && (
        <>
          <div className="forum-sidebar__section-label">KATEGORİ</div>
          {categoryFilterOptions.map((opt) => (
            <button
              key={opt.value || 'all'}
              type="button"
              onClick={() => onCategoryChange(opt.value)}
              className={`forum-nav-btn${category === opt.value ? ' forum-nav-btn--category-active' : ''}`}
            >
              {sidebarOpen && <span>{opt.label}</span>}
            </button>
          ))}

          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            onClick={onNewTopic}
            className="forum-sidebar__new-btn"
          >
            <Plus size={18} />
            Yeni konu
          </motion.button>
        </>
      )}
    </div>
  </motion.aside>
);

export default ForumSidebar;
